<template>
	<div
		class="media-preset-container"
		:selected="selected"
		:tabindex="tabindex"
		@click="handleClick($event)"
	>
		<div class="media-preset-header">
			<slot name="header" />
		</div>
		<div class="media-preset-content">
			<slot />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "MediaPreset",
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		selected: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			e.stopPropagation();
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
div.media-preset-container {
	display: flex;
	flex-direction: column;

	border-radius: 12px;
	border: 1px solid var(--slideout-border);
	background-color: var(--slideout-element-light);

	> div.media-preset-header {
		padding: 16px;
	}

	> div.media-preset-content {
		padding: 0px 16px 16px 16px;
	}

	&:active {
		filter: contrast(90%);
	}

	&:hover:not(:active) {
		filter: contrast(95%);
	}
	&:focus {
		box-shadow: inset 0 0 0 1px var(--slideout-primary);
		outline: none;
	}

	&[selected] {
		box-shadow: inset 0 0 0 1px var(--slideout-success);
		outline: none;
	}
}
</style>
